import axios from "axios";
import { getHeaders } from "../amplify/sessionManager";
import { mapErrorToMessage } from "./utils/mapErrorToMessage";
import { mapErrorToTittle } from "./utils/mapErrorToTittle";
import Swal from "sweetalert2";
import theme from "../../../components/foundations/themes";

const axiosInstanceBuilder = (baseUrl, addHeaders = true) => {
  const axiosInstance = axios.create({
    baseURL: baseUrl,
  });

  if (addHeaders) {
    axiosInstance.interceptors.request.use(async (config) => {
      config.headers = await getHeaders();
      return config;
    });
  }

  axiosInstance.interceptors.response.use(undefined, (error) => {
    const message = mapErrorToMessage(error);
    const title = mapErrorToTittle(error);
    Swal.fire({
      title: title,
      text: message,
      icon: "error",
      confirmButtonText: "Got it",
      confirmButtonColor: theme.palette.primary.main,
    });
    return Promise.reject(message);
  });

  return axiosInstance;
};

export default axiosInstanceBuilder;
